<template>
  <div class="table">
    <div class="table-header">
      <div class="row th">
        <span class="column long-column">
          <span> {{ $lang.messages.summary }} </span>
        </span>
        <span class="column pointer" @click="sort('payor')">
          <span> {{ $lang.messages.payor }} </span>
          <img
            src="@/assets/images/payments/arrow_down_small.png"
            class="sort-indicator-down"
            :class="{ 'sort-indicator-up': 'desc' === currentSortDir && 'payor' === currentSort }"
          />
        </span>
        <span class="column pointer" @click="sort('recipient')">
          <span> {{ $lang.messages.recipient }} </span>
          <img
            src="@/assets/images/payments/arrow_down_small.png"
            class="sort-indicator-down"
            :class="{ 'sort-indicator-up': 'desc' === currentSortDir && 'recipient' === currentSort }"
          />
        </span>
        <span class="column pointer" @click="sort('paymentDate')">
          <span> {{ $lang.messages.dueDate }} </span>
          <img
            src="@/assets/images/payments/arrow_down_small.png"
            class="sort-indicator-down"
            :class="{ 'sort-indicator-up': 'desc' === currentSortDir && 'dueDate' === currentSort }"
          />
        </span>
        <span class="column middle-column center-aligned-column">
          <span> {{ $lang.messages.status }} </span>
        </span>
        <span class="column right-aligned-column pointer" @click="sort('amount')">
          <span> {{ $lang.messages.amount }} </span>
          <img
            src="@/assets/images/payments/arrow_down_small.png"
            class="sort-indicator-down"
            :class="{ 'sort-indicator-up': 'desc' === currentSortDir && 'amount' === currentSort }"
          />
        </span>
        <span class="column short-column center-aligned-column">
          <img :src="getImgUrl('schedule_ico')" :alt="'schedule_ico'" />
        </span>
        <span class="column short-column center-aligned-column">
          <img :src="getImgUrl('note_ico')" :alt="'note_ico'" />
        </span>
        <span class="column short-column center-aligned-column column-icons">
          <img :src="getImgUrl('attachment_ico')" :alt="'attachment_ico'" />
        </span>
        <span class="column short-column center-aligned-column">
          <img :src="getImgUrl('discuss_ico')" :alt="'discuss_ico'" />
        </span>
        <span class="column short-column center-aligned-column">
          <span> {{ $lang.messages.actions }} </span>
        </span>
      </div>
    </div>
    
    <div class="table-body">
      <div v-show="loading" class="skeleton-screen" v-for="(i) of loadingArray">
      </div>
      <section v-show="!loading" v-if="list.length !== 0">
        <div
          v-for="(expense, indexTransHistory) in list"
          :key="indexTransHistory"
          class="row th pointer"
          @click="showDetails(expense, $event)"
        >
        <span class="column long-column">
          <div class="column-name"> {{ $lang.messages.summary }} </div>
          <span class="column-data" :title="expense.summary"> {{ expense.summary }} </span>
        </span>
    
          <div class="column">
            <div class="column-name"> {{ $lang.messages.payor }} </div>
            <span class="column-data" :title="expense.payor"> {{ expense.payor }} </span>
          </div>
    
          <div class="column">
            <div class="column-name"> {{ $lang.messages.recipient }} </div>
            <span class="column-data" :title="expense.recipient"> {{ expense.recipient }} </span>
          </div>
    
          <div class="column">
            <div class="column-name"> {{ $lang.messages.dueDate }} </div>
            <span class="column-data date" :title="dateFormat(expense.dueDate)"> {{ dateFormat(expense.dueDate) }} </span>
          </div>
    
          <div class="column middle-column center-aligned-column">
            <div class="column-name"> {{ $lang.messages.status }} </div>
            <button
              class="lbl"
              :class="
                expense.status.toLowerCase() === 'paid' ?
                'lbl-paid' : expense.status.toLowerCase() === 'pending' ?
                'lbl-pending' : 'lbl-paid-externally'
              ">
              {{
                expense.status.toLowerCase() === 'paid' ?
                '✓ ' + $lang.messages.paid : expense.status.toLowerCase() === 'pending' ?
                $lang.messages.pending : expense.status.toLowerCase() === 'digital_check' ?
              '🗸 ' + $lang.messages.digitalCheck : '✓ ' + $lang.messages.paidExternally
              }}
            </button>
          </div>
    
          <div class="column right-aligned-column bold-column">
            <div class="column-name"> {{ $lang.messages.amount }} </div>
            <span class="column-data amount">
              <currency-sign :currency="expense.currency"></currency-sign>{{ currencyFormat(expense.amount) }}
            </span>
          </div>
    
          <span class="column short-column center-aligned-column scheduled-ico">
          <span v-if="expense.scheduled == null">
            <img src="@/assets/images/payments/schedule_ico_disabled.png" />
          </span>
          <div class="my-tooltip">
            <img
              v-if="expense.scheduled != null"
              src="@/assets/images/payments/schedule_ico.png"
            />
            <span class="tooltiptext">{{ expense.scheduled }}</span>
          </div>
        </span>
    
          <span class="column short-column center-aligned-column">
          <span v-if="expense.note === '' || expense.note == null">
            <img src="@/assets/images/payments/note_ico_disabled.png" />
          </span>
          <div class="my-tooltip">
            <img
              v-if="expense.note !== '' && expense.note != null"
              src="@/assets/images/payments/note_ico.png"
            />
            <span class="tooltiptext">{{ expense.note }}</span>
          </div>
        </span>
    
          <span class="column short-column center-aligned-column column-icons">
          <span v-if="expense.attachments.length === 0">
            <img src="@/assets/images/payments/attachment_ico_disabled.png" />
          </span>
          <span v-if="expense.attachments.length >= 1">
            <f-p-documents :type="expense.firstExtension" :isHistoryPayments="true"></f-p-documents>
            <f-p-documents :type="expense.secondExtension" :isHistoryPayments="true"></f-p-documents>
            <span>
              <div
                v-if="expense.documentCount >= 1"
                class="document-count"
              >
                +{{ expense.documentCount }}
              </div>
            </span>
          </span>
        </span>
    
        <span class="column short-column center-aligned-column">
          <span v-if="expense.commentCount === 0">
            <img src="@/assets/images/payments/discuss_ico_passive.png" />
            <div class="notifications-marker disabled">
              {{ expense.commentCount }}
            </div>
          </span>
          <span v-if="expense.commentCount > 0">
            <img src="@/assets/images/payments/discuss_ico.png" />
            <div class="notifications-marker">
              {{ expense.commentCount }}
            </div>
          </span>
        </span>
    
        <span
          class="column short-column center-aligned-column actions-ico"
          id="actions-ico"
          @click="toggleActions(expense.guid)">
          <img src="@/assets/images/payments/actions_ico.png" />
          <div class="action-menu" :class="[ actionsRowId === expense.guid && actions ? 'select-menu-collapsed' : 'select-menu-not-collapsed' ]">
            <router-link :to="{ name: computedRoute(expense.expenseType), params: { id: expense.guid }}">
              <div class="item">{{ $lang.messages.view }}</div>
            </router-link>
            <router-link :to="{ name: computedRoute(expense.expenseType), params: { id: expense.guid, discuss: discuss }}">
              <div class="item">{{ $lang.messages.discuss }}</div>
            </router-link>
          </div>
        </span>
        </div>
      </section>
    </div>
    
    <f-p-pagination
      v-if="!mockData"
      :paginationParams="paginationParams"
      @onPaginationChanged="onPaginationChanged"
      ref="pagination">
    </f-p-pagination>
  </div>
</template>

<script>
  import { getImgUrl } from '@/mixins/fpTableHelper'
  import { currencyFormat } from "@/mixins/currencyFormat";
  import { dateFormat } from "@/mixins/dateFormat";
  import CurrencySign from "@/components/common/CurrencySign"
  import FPPagination from "./FPPagination";
  import FPDocuments from '@/components/common/FPDocuments';

  export default {
    name: "FPTableTransactionHistory",
    components: {
      CurrencySign,
      FPPagination,
      'f-p-documents': FPDocuments
    },
    mixins: [
      currencyFormat,
      getImgUrl,
      dateFormat
    ],
    props: {
      list: {
        type: Array,
        required: true,
        default: () => []
      },
      paginationParams: {
        type: Object,
        required: true,
        default: () => {}
      },
      mockData: {
        type: Boolean,
        required: true,
        default: () => false
      },
      loading: {
        type: Boolean,
        required: false,
        default: () => true,
      },
    },
    data() {
      return {
        actions: false,
        actionsRowId: 0,
        currentSort: "",
        currentSortDir: "ASC",
        allChecked: false,
        checkedList: [],
        discuss: true,
        checkedExpensesAll: [],
        loadingArray: [{}, {}]
      };
    },
    mounted() {
      this.onClickOutside()
      this.setTooltips()
    },
    methods: {
      onClickOutside() {
        let _this = this;
        document.addEventListener('click', function(e) {
          let dropdown = document.querySelector('.select-menu-type-2');
          let clickedElement = e.target;
          
          if (clickedElement.className.indexOf('item') !== 0) {
            if (clickedElement.className.indexOf('actions-ico') === -1 && clickedElement !== dropdown) {
              _this.actions = false;
            }
          } else {
            _this.actions = !_this.actions;
          }
          
        });
      },
      setTooltips() {
        let tooltips = document.getElementsByClassName('tooltiptext')
        
        for (let item of tooltips) {
          let height = item.offsetHeight
          if (height >= 30 && height <= 40) {
            item.style.marginTop = "4px"
          } else if (height >= 41 && height <= 50) {
            item.style.marginTop = "-4px"
          } else if (height >= 51 && height <= 60) {
            item.style.marginTop = "-8px"
          } else if (height >= 61 && height <= 70) {
            item.style.marginTop = "-12px"
          } else if (height >= 71 && height <= 80) {
            item.style.marginTop = "-16px"
          } else if (height >= 81 && height <= 100) {
            item.style.marginTop = "-20px"
          } else if (height >= 101) {
            item.style.marginTop = "-24px"
          }
        }
      },
      toggleActions(guid) {
        this.actions = !this.actions;
        this.actionsRowId = guid;
      },
      sort(param) {
        if (param === this.currentSort) {
          this.currentSortDir = this.currentSortDir === "ASC" ? "DESC" : "ASC";
        }
        this.currentSort = param;
        this.$refs.pagination.goToPage(1);
        this.$emit("sort", this.currentSort, this.currentSortDir);
      },
      onPaginationChanged() {
        this.$emit("on-pagination-changed-table", this.paginationParams);
      },
      computedRoute(expenseType) {
        return (
            expenseType === this.$ALIMONY_EXPENSE_TYPE ?
            'ExpenseDetailsSpousalMaintenance' : expenseType === this.$CHILD_EXPENSE_TYPE ?
            'ExpenseDetailsChildMaintenance' : 'ExpenseDetailsSharedExpenses'
        );
      },
      showDetails(expense, e) {
        if (e.target.id !== 'actions-ico') {
          this.$router.push({ name: this.computedRoute(expense.expenseType), params: { id: expense.guid } })
        }
      },
    },
  };
</script>
